import BillDateWithTimezone from "@/common/components/BillDateWithTimezone";
import { billingBillStatus } from "@/common/constants/statusBills.constants";
import { formatCurrency } from "@/common/utils/formatters";
import { EstablishmentBillData } from "@/features/establishments/types/establishmentBills.type";
import { ArrowBigRightIcon } from "lucide-react";
import { Link } from "react-router-dom";

export class EstablishmentBillsTransformer {
  static tableTransformer() {
    return (companyBills: EstablishmentBillData[]) => {
      return companyBills.map((bill) => ({
        ...bill,
        status: billingBillStatus.find((option) => option.value === bill.status)
          ?.label,
        total_amount: bill?.total_amount
          ? formatCurrency(parseFloat(`${bill?.total_amount}`))
          : "Não informado",
        opened_at: bill?.opened_at && (
          <BillDateWithTimezone
            date={bill.opened_at}
            timezone={bill.time_zone}
          />
        ),
        closed_at: bill?.closed_at && (
          <BillDateWithTimezone
            date={bill.closed_at}
            timezone={bill.time_zone}
          />
        ),
        events_count: `${bill.events_count} transações`,
        actions: (
          <div className="flex items-center gap-4">
            <Link to={bill.id} data-testid="show_bill_button">
              <ArrowBigRightIcon strokeWidth={1} />
            </Link>
          </div>
        ),
      }));
    };
  }
}
